import getHoldingClassInvestmentsConsiderationValues from './get-holding-class-investments-consideration-values';
import {
  WithholdingTaxAllocation,
  MinimumHoldingClassRealisation,
} from 'further-types/lp/realisation';

const getHoldingClassCashConsiderationValues = ({
  holdingClassId,
  investmentId,
  holdingClassRealisations,
  withholdingTaxList,
}: {
  holdingClassId: string;
  investmentId: string;
  holdingClassRealisations: Array<MinimumHoldingClassRealisation>;
  withholdingTaxList: Array<WithholdingTaxAllocation>;
}) => {
  const holdingClassInvestmentsWithConsiderationValues =
    getHoldingClassInvestmentsConsiderationValues({
      holdingClassRealisations,
      withholdingTaxList,
    });

  const cashConsiderationValues =
    holdingClassInvestmentsWithConsiderationValues.find(
      (holdingClassInvestment) =>
        holdingClassInvestment.holdingClassId === holdingClassId &&
        holdingClassInvestment.investmentId === investmentId,
    );

  return cashConsiderationValues;
};

export default getHoldingClassCashConsiderationValues;
